import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { ImageTitleDescriptionModel } from './image-title-description-model';

import { IArchLineSectionProps } from '../components/arch-line-section/arch-line-section';

export class ArchLineSectionModel extends ContentItem {
  get children(): IKontentItem[] {
    const getChildren = get(this._config, 'elements.items.value', []);
    const transformChildren = getChildren
      ? getChildren.map((children: IKontentItem) =>
          ImageTitleDescriptionModel.create(children as IImageTitleDescription)
        )
      : null;
    return transformChildren;
  }

  public static create(data: IArchLineSection): IArchLineSectionProps {
    const { children } = new ArchLineSectionModel(data);
    return {
      children
    };
  }
}
